import {QualityControlApprovalsFormField} from "../types/quality-control-approvals-form-field.types";
import {Validators} from "@angular/forms";

export const qualityControlApprovalsFormFields: Array<QualityControlApprovalsFormField> = [
  {
    fieldName: 'approvalStatus',
    label: 'Статус согласования',
    type: 'select',
    validators: [ Validators.required ]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea'
  }
]
